// src/data/products.js
// Updated for USA market - prices in USD, US-focused descriptions

export const products = [
  {
    id: 1,
    name: "Standard Gabion Basket",
    size: "50cm × 50cm × 50cm (≈ 20\" × 20\" × 20\")",
    specs: "4.0mm Galfan Coated • Ideal for small garden features, decorative walls, borders, and low retaining walls. Excellent corrosion resistance for all U.S. climates.",
    price: 65,
    image: "/images/gabion-size-4.jpg",
    alt: "Standard 50cm gabion basket - Galfan coated gabion basket for landscaping and retaining walls USA",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 2,
    name: "Compact Gabion Basket",
    size: "100cm × 30cm × 30cm (≈ 3'3\" × 1' × 1')",
    specs: "4.0mm Galfan Coated • Perfect for garden edging, borders, terracing, and low landscape features. Great for DIY projects across the USA.",
    price: 72,
    image: "/images/gabion-size-5.jpg",
    alt: "Compact gabion basket for garden borders and edging - ships nationwide USA",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 3,
    name: "Large Retaining Basket",
    size: "100cm × 50cm × 30cm (≈ 3'3\" × 1'8\" × 1')",
    specs: "4.0mm Galfan Coated • Excellent for low retaining walls, terraced gardens, and erosion control. Built tough for American landscapes.",
    price: 79,
    image: "/images/gabion-size-6.jpg",
    alt: "Large gabion basket for retaining walls and erosion control - nationwide shipping USA",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 4,
    name: "Extra Large Gabion Basket",
    size: "100cm × 50cm × 50cm (≈ 3'3\" × 1'8\" × 1'8\")",
    specs: "4.0mm Galfan Coated • Versatile choice for medium retaining walls, garden structures, and landscaping projects. Fast shipping to all 50 states.",
    price: 95,
    image: "/images/gabion-size-7.jpg",
    alt: "Extra large gabion basket for retaining walls - premium Galfan coated, ships nationwide USA",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 5,
    name: "Heavy Duty Retaining Basket",
    size: "100cm × 100cm × 50cm (≈ 3'3\" × 3'3\" × 1'8\")",
    specs: "4.0mm Galfan Coated • Best for taller retaining walls, commercial projects, and heavy-duty erosion control. Ideal for slopes and large-scale U.S. projects.",
    price: 128,
    image: "/images/gabion-size-8.jpg",
    alt: "Heavy duty gabion basket for commercial retaining walls - nationwide delivery USA",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 6,
    name: "Large Structural Gabion",
    size: "100cm × 100cm × 100cm (≈ 3'3\" × 3'3\" × 3'3\")",
    specs: "4.0mm Galfan Coated • Ideal for structural retaining walls, large installations, and major erosion control projects. Strong and durable for demanding U.S. applications.",
    price: 145,
    image: "/images/gabion-size-300.jpg",
    alt: "Large structural gabion for retaining walls and erosion control - ships to all USA states",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  }
];